// extracted by mini-css-extract-plugin
export default {"root":"Autocomplete_root__7QhXG","input":"Autocomplete_input__83LUb","suggestions":"Autocomplete_suggestions__YxetG","listItem":"Autocomplete_listItem__CRaoL"};